<template>
  <div :class="['logo', type]"
       @click="toHome"
       :style="{backgroundImage: 'url(' + logoImage + ')'}">
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .logo{
    cursor: pointer;
    height: 40px;
    width: 150px;
    background-repeat: no-repeat!important;
    background-position: left top!important;
    background-size: auto 40px;
    &.logged{
      height: 56px;
      width: 240px;
      background-size: auto 56px;
    }
  }
</style>
<script>
export default {
  name: 'Logo',
  props: {
    type: { // logo  logged: 登录后的; 登录前页面的(默认)
      type: String,
      default: ''
    },
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    logoImage () {
      // 登录前的logo
      let src = require('assets/images/logo/r2-logo.png')
      if (this.isWhite) {
        // 蓝色的logo
        src = require('assets/images/logo/r2-logo-blue.png')
      }
      // 登录后的logo
      if (this.type === 'logged') {
        src = require('assets/images/logo/r2-logo-h-56.png')
      }
      if (!this.isCostCloud) {
        src = require('assets/images/cfmcc/cfmcc-logo.png')
      }
      return src
    }
  },
  methods: {
    toHome () {
      if (this.isCostCloud) {
        this.$router.push({
          path: '/'
        })
      } else {
        this.$router.push({
          path: '/login'
        })
      }
    }
  }
}
</script>
